import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertOfferNotFoundStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.OfferNotFound) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendOfferNotFound);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Объявление снято с публикации или удалено' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: бэкенд не нашёл объявление',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
